/** Translate bounded backend outcome codes; never show raw automation errors. */
export function gleanFailureMessage(code?: string | null): string {
  const messages: Record<string, string> = {
    COMPOSER_NOT_FOUND: "Could not locate Glean's chat input. Check the Glean page, or copy the prompt and send it yourself.",
    PROMPT_MISMATCH: "Your prompt could not be entered correctly. Nothing was sent. Copy the prompt and send it in Glean.",
    NAVIGATION_FAILED: "Glean could not open. Check your connection and access to Glean.",
    TIMEOUT: "Glean automation timed out. Check Glean before sending again.",
    SUBMISSION_UNCERTAIN: "We couldn't confirm whether your prompt was sent. Check Glean before sending again.",
    HELPER_RESTARTED: "Glean automation restarted before the result was confirmed. Check Glean before sending again.",
    SIGN_IN_REQUIRED: "Sign in to Glean in the automation browser to continue.",
    AUTOMATION_FAILED: "Glean automation could not complete your request. Check Glean before sending again.",
    SUBMISSION_FAILED: "Submission failed. Check Glean before sending the prompt again.",
    GLEAN_ACCESS_DENIED: "You no longer have access to the selected content. Select an accessible response and prepare a new prompt.",
    INVALID_JOB: "This handoff is no longer available. Check Glean before preparing another prompt.",
    JOB_EXPIRED: "This handoff expired. Prepare your prompt again from the S button.",
    REVIEW_REQUIRED: "Review the prompt in the opened Velocity tab, then choose Approve.",
  };
  return messages[code ?? ""] ?? "Glean automation could not complete your request. Check Glean before sending again.";
}
